// extracted by mini-css-extract-plugin
export default {"root":"ExternalCollaboratorCredit-module--root--64c73","lg":"ExternalCollaboratorCredit-module--lg--a435f","sm":"ExternalCollaboratorCredit-module--sm--dec40"};